/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import Uri from 'jsuri';

import path from 'js/lib/path';

import { CartIcon } from '@coursera/cds-icons';

import { useShoppingCart } from 'bundles/composable-page-header-consumer/contexts/ShoppingCartContext';
import { TrackedA } from 'bundles/page/components/TrackedLink2';
import constants from 'bundles/payments/common/constants';
import savedCartUtils from 'bundles/payments/lib/savedCartUtils';

import _t from 'i18n!nls/composable-page-header-consumer';

const styles = {
  link: css`
    display: block;
    padding: var(--cds-spacing-150) 20px var(--cds-spacing-150) var(--cds-spacing-150) !important;
    transition: background-color 0.3s ease;

    :hover {
      background-color: var(--cds-color-interactive-background-primary-hover-weak) !important;
    }
  `,
  cartIconContainer: css`
    position: relative;
  `,
  cartIcon: css`
    width: var(--cds-spacing-300);
    height: var(--cds-spacing-300);
    display: block;
  `,
  cartItemCounter: css`
    line-height: normal;
    display: block;
    position: absolute;
    font-size: var(--cds-spacing-150);
    top: 4px;
    right: 4px;
    width: var(--cds-spacing-200);
    height: var(--cds-spacing-200);
    border-radius: 50%;
    color: var(--cds-color-white-0);
    text-align: center;
    background-color: var(--cds-color-blue-700);
    margin-top: -50%;
    margin-right: -50%;
  `,
};

const getCartPageUrl = () => {
  const cartInfo = savedCartUtils.get();
  const cartId = cartInfo && cartInfo.id;

  if (cartId) {
    return new Uri()
      .setPath(path.join(constants.rootPath, constants.cartUrl))
      .addQueryParam('cartId', cartId.toString())
      .toString();
  } else {
    return '/';
  }
};

const ShoppingCartGridItem = () => {
  const shoppingCart = useShoppingCart();
  const cartPageUrl = React.useMemo(() => getCartPageUrl(), []);

  React.useEffect(() => {
    if (!shoppingCart?.loading && !shoppingCart?.isValidCart) {
      savedCartUtils.reset();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!shoppingCart?.isValidCart) {
    return null;
  }

  return (
    <TrackedA trackingName="cart" href={cartPageUrl} css={styles.link}>
      <div css={styles.cartIconContainer} aria-label={_t('Shopping cart: 1 item')}>
        <CartIcon size="large" css={styles.cartIcon} color="support" />
        <span css={styles.cartItemCounter}>1</span>
      </div>
    </TrackedA>
  );
};

export default ShoppingCartGridItem;
